import React, { useState } from 'react';
import {
  Button,
  Chip,
  Collapse,
  Divider,
  Icon,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { format, parseISO } from 'date-fns';


const FilterDrawer = ({ setOpenFilter, setFilterConditions, filterConditions }) => {
  const [expandedFirstName, toggleExpandedFirstName] = useState(false);
  const [expandedLastName, toggleExpandedLastName] = useState(false);
  const [expandedEmail, toggleExpandedEmail] = useState(false);
  const [expandedPhone, toggleExpandedPhone] = useState(false);
  const [expandedRewardPoints, toggleExpandedRewardPoints] = useState(false);
  const [expandedLastPurchase, toggleExpandedLastPurchase] = useState(false);
  const [expandedTotalSpend, toggleExpandedTotalSpend] = useState(false);

  const [conditions, setConditions] = useState({
    firstName: filterConditions.firstName || '',
    lastName: filterConditions.lastName || '',
    email: filterConditions.email || '',
    phone: filterConditions.phone || '',
    rewardPoints: filterConditions.rewardPoints || '',
    lastPaymentFrom: filterConditions.lastPaymentFrom || '',
    lastPaymentTo: filterConditions.lastPaymentTo || '',
    totalSpend: filterConditions.totalSpend || ''
  });

  const handleChangeFilter = (name, value) => {
    setConditions((prevConditions) => ({
      ...prevConditions,
      [name]: value
    }));
  };

  const handleApplyFilter = () => {
    const filteredConditions = Object.fromEntries(
      Object.entries(conditions).filter(([_key, value]) => value)
    );

    setFilterConditions(filteredConditions);
    setOpenFilter(false);
  };

  const setConvertedDate = (value) => {
    const date = new Date(value);
    return date.toUTCString();
  };

  const handleClearDate = (event, name) => {
    event.preventDefault();
    event.stopPropagation();
    setConditions((prevConditions) => ({
      ...prevConditions,
      [name]: ''
    }));
  };

  return (
    <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
      <div>
        <div className="flex items-center justify-between mb-2">
          <Typography variant="h5" className="text-primary uppercase">Filter by:</Typography>
          <IconButton onClick={() => setOpenFilter(false)}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>

        <div className="flex items-center flex-wrap mb-2">
          {Object.entries(conditions).map(([name, value], index) => {
            if (!value) {
              return null;
            }

            let label = value.replace(/%/g, '');

            if (name === 'lastPaymentFrom' || name === 'lastPaymentTo') {
              label = `${name === 'lastPaymentFrom' ? 'From' : 'To'}: ${format(parseISO(value.replace(/%/g, '')), 'MM/dd/yyyy')}`;
            }

            return (
              <div key={`filter-${index}`} className="mr-2 mb-2">
                <Chip
                  label={label}
                  onDelete={() => setConditions((prevConditions) => ({
                    ...prevConditions,
                    [name]: ''
                  }))}
                />
              </div>
            );
          })}
        </div>

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedFirstName((prev) => !prev)}
        >
          <Typography variant="h6">First Name</Typography>
          {expandedFirstName ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedFirstName} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="firstName"
            label="First Name"
            value={conditions.firstName.replace(/%/g, '')}
            onChange={(event) => handleChangeFilter(event.target.name, `%${event.target.value}%`)}
          />
        </Collapse>
        <Divider className="my-5" />

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedLastName((prev) => !prev)}
        >
          <Typography variant="h6">Last Name</Typography>
          {expandedLastName ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedLastName} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="lastName"
            label="Last Name"
            value={conditions.lastName.replace(/%/g, '')}
            onChange={(event) => handleChangeFilter(event.target.name, `%${event.target.value}%`)}
          />
        </Collapse>
        <Divider className="my-5" />

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedEmail((prev) => !prev)}
        >
          <Typography variant="h6">Email</Typography>
          {expandedEmail ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedEmail} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="email"
            label="Email"
            value={conditions.email.replace(/%/g, '')}
            onChange={(event) => handleChangeFilter(event.target.name, `%${event.target.value}%`)}
          />
        </Collapse>
        <Divider className="my-5" />

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedPhone((prev) => !prev)}
        >
          <Typography variant="h6">Phone</Typography>
          {expandedPhone ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedPhone} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="phone"
            label="Phone"
            value={conditions.phone.replace(/%/g, '')}
            onChange={(event) => handleChangeFilter(event.target.name, `%${event.target.value}%`)}
          />
        </Collapse>
        <Divider className="my-5" />

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedRewardPoints((prev) => !prev)}
        >
          <Typography variant="h6">Reward Points</Typography>
          {expandedRewardPoints ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedRewardPoints} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="rewardPoints"
            label="Reward Points"
            value={conditions.rewardPoints}
            onChange={(event) => handleChangeFilter(event.target.name, event.target.value)}
          />
        </Collapse>
        <Divider className="my-5" />

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedLastPurchase((prev) => !prev)}
        >
          <Typography variant="h6">Last Purchase Date</Typography>
          {expandedLastPurchase ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedLastPurchase} timeout="auto">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              disableFuture
              autoOk
              fullWidth
              variant="inline"
              format="MM/dd/yyyy"
              emptyLabel="mm/dd/yyyy"
              name="lastPaymentFrom"
              label="From"
              className="mt-5"
              value={conditions.lastPaymentFrom ? setConvertedDate(conditions.lastPaymentFrom) : null}
              onChange={(date) => handleChangeFilter('lastPaymentFrom', `${format(date, 'yyyy-MM-dd 00:00:00')}`)}
              inputVariant="outlined"
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <CalendarTodayIcon className="text-muted text-16" />
                ),
                endAdornment: (
                  <Icon className="cursor-pointer" onClick={(event) => handleClearDate(event, 'lastPaymentFrom')}>close</Icon>
                )
              }}
            />
            <DatePicker
              disableFuture
              autoOk
              fullWidth
              variant="inline"
              format="MM/dd/yyyy"
              emptyLabel="mm/dd/yyyy"
              name="lastPaymentTo"
              error={conditions.lastPaymentTo < conditions.lastPaymentFrom}
              helperText={conditions.lastPaymentTo < conditions.lastPaymentFrom && 'End Date cant be less than Start Date'}
              label="To"
              className="mt-5"
              value={conditions?.lastPaymentTo ? setConvertedDate(conditions.lastPaymentTo) : null}
              onChange={(date) => handleChangeFilter('lastPaymentTo', `${format(date, 'yyyy-MM-dd 23:59:59')}`)}
              inputVariant="outlined"
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <CalendarTodayIcon className="text-muted text-16" />
                ),
                endAdornment: (
                  <Icon
                    className="cursor-pointer"
                    onClick={(event) => handleClearDate(event, 'last_run_to')}
                  >
                    close
                  </Icon>
                )
              }}
            />
          </MuiPickersUtilsProvider>
        </Collapse>
        <Divider className="my-5" />

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedTotalSpend((expandedTotalSpend) => !expandedTotalSpend)}
        >
          <Typography variant="h6">Total Spent</Typography>
          {expandedTotalSpend ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedTotalSpend} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="totalSpend"
            label="Total Spent"
            value={conditions.totalSpend.value}
            onChange={(event) => handleChangeFilter(event.target.name, event.target.value)}
          />
        </Collapse>

      </div>
      <div className="flex items-center justify-between my-4">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="mr-2 uppercase"
          onClick={handleApplyFilter}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          fullWidth
          className="uppercase"
          onClick={() => {
            setFilterConditions({});
            setOpenFilter(false);
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default FilterDrawer;
